import { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom"; 
import { TestContext } from "../../context/testContext";
import Loader from "../../UI/Loader/Loader";
import { AuthContext } from "../../context/authContext"; 
import СoveredBackground from "../../UI/СoveredBackground/СoveredBackground";

const TestPage = () => { 
  const [testStart, setTestStart] = useState(null);
  const { loading, checkActualTest, testContinue, uploadPage, setFinish, } = useContext(TestContext);
  const {logout} = useContext(AuthContext)
   

  useEffect(() => {
    document.title = "Тестирование"
    uploadPage()
    setFinish(null)
    checkActualTest().then((res) => {
      setTestStart(res.data);
      
    }).catch(err => {
          if(err.response.status === 401) {
            logout()
          }
        })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);










  

  return (
    <section className="test">
      <div className="container">
        <div className="test__wrapper">
          {loading && (
            <СoveredBackground>
              <Loader />
            </СoveredBackground>
          )}

          {(testStart || testContinue) ? (
      
              <>
                <div className="test__wrapper__text">
                  Тестовые вопросы сформированы, начнем?
                </div>
                <Link to="/test/pass" className="test__wrapper__link">{testContinue? <>Продолжить</>:<>Начать</>}</Link>
              </>

          ) : (
            <div className="test__wrapper__text">Нет доступных тестов</div>
          )}
        </div>
      </div>
    </section>
  );
};

export default TestPage;
